export const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
};

export const validatePhoneNumber = (typedNumber) => {
    let val = typedNumber.trim();
    val = val.replace(/[^0-9]/g, '');
    return val;
};